import React from 'react';
import MaterialTextField from '@material-ui/core/TextField';

const TextField = (props) => {
    let className = '';
    if (props.multiline) {
        className += 'multiline';
    }

    return (
        <MaterialTextField className={className} variant="outlined" size="small"
                           fullWidth={true} InputLabelProps={{shrink: true}} {...props}
        />
    );
};

export default TextField;
